export const BadgeTypes = {
  DEFAULT: 'default',
  INFO: 'info',
  ATTENTION: 'attention',
  VALIDATED: 'validated',
  ALERT: 'alert',
  ALTERNATIVE: 'alternative',
  BLOCKED: 'blocked',
}
